import React from 'react'
import PhotoViewer from '../PhotoViewer';
import { Container } from './styles'

interface Props {
    photos: {
        arrayPhoto: string[],
        positionPhoto: number
    }
}
//Show full size photo
const PhotoContent: React.FC<Props> = ({ photos }) => {


    return (
        <>
            <Container>
                <PhotoViewer src={photos.arrayPhoto[photos.positionPhoto]} />
            </Container>
        </>
    )
}

export default PhotoContent
